export enum ErrorResponse {
    'IMMEDIATE',
    'DIRTY',
    'TOUCHED'
}
